import axios from '@/plugins/axios'
import { Module } from 'vuex'

const campaignModule: Module<any, any> = {
    state: {
        filters: {},
    },
    actions: {
        async pauseCampaign(_, params) {
            const url = `/api/campaigns/${params.id}/pause`
            const { data } = await axios.put(url, { pause: params.pause })
            return data
        },
        async abortCampaign(_, id) {
            const url = `/api/campaigns/${id}/abort`
            const { data } = await axios.put(url, {})
            return data
        },
        async deleteCampaign(_, id) {
            const url = `/api/campaigns/${id}`
            const { data } = await axios.delete(url)
            return data
        },
        async cancelCampaign(_, id) {
            const url = `/api/campaigns/${id}/cancel`
            const { data } = await axios.put(url, {})
            return data
        },
        async getCampaigns(_, params) {
            let url = `/api/campaigns?itemPerPage=${params.perPage}&page=${params.page}`

            url += `&status=${params?.status ?? 'active'}`

            if (params.search) {
                url += `&search=${params.search}`
            }

            if (params.campaignType) {
                url += `&campaignType=${params.campaignType}`
            }

            if (params.contentIds) {
                url += `&contentIds=${params.contentIds}`
            }

            if (params.from) {
                url += `&createdAt[after]=${params.from}`
            }

            if (params.to) {
                url += `&createdAt[before]=${params.to}`
            }
            if (params.sortKey)
            {
                url += `&sort=${params.sortKey}`
            }

            if (params.sortOrder)
            {
                url += `&order=${params.sortOrder}`
            }

            const { data } = await axios.get(url)
            return data
        },
        async createCampaign(_, params) {
            await axios.post('/api/campaigns', params)
        },
    },
    mutations: {
        clearCampaignFilters(state: any) {
            state.filters = {}
        },
    },
}

export default campaignModule
